import React, { lazy, Suspense } from "react";
import { BrowserRouter as Router, Route } from "react-router-dom";
import { connect } from "react-redux";
import RequireAuth from "./utils/requireAuth";
import Heading from "./component/Heading";
import SideMenu from "./component/SiderBar";
import Footer from "./component/Footer";
const Login = lazy(() => import("./containers/Login"));
const Register = lazy(() => import("./containers/Register"));
const UsersSettings = lazy(() => import("./containers/users/UsersSettings"));
const AddAzureAccount = lazy(() => import("./containers/users/AddAccount"));
const AddGCPAccount = lazy(() => import("./containers/users/AddGCPAccount"));
const forgotPwd = lazy(() => import("./containers/users/ForgotPwd"));
const resetPwd = lazy(() => import("./containers/users/ResetPwd"));
const users = lazy(() => import("./containers/users"));
const azure = lazy(() => import("./containers/azure"));
const azurebilling = lazy(() => import("./containers/azurebilling"));
const azureForecastbilling = lazy(() =>
  import("./containers/azureForecastbilling")
);
const azuresubcription = lazy(() => import("./containers/azuresubcription"));
const azureactivitylogs = lazy(() => import("./containers/azureactivitylogs"));
const azurevms = lazy(() => import("./containers/azurevms"));
const azurevmsimages = lazy(() => import("./containers/azurevmsimages"));
const azuredatabases = lazy(() => import("./containers/azuredatabases"));
const azurestorageaccounts = lazy(() =>
  import("./containers/azurestorageaccounts")
);
const AzureStorageaccountsContainer = lazy(() =>
  import("./containers/azurestorageaccounts/AzureStorageaccountsContainer")
);
const azureSites = lazy(() => import("./containers/azuresites"));
const azureFunctionalApp = lazy(() =>
  import("./containers/azurefunctionalapp")
);
// const azureLoadBalancer = lazy(() => import("./containers/azureloadbalancer"));
const azureAlertRules = lazy(() => import("./containers/azurealertrules"));
const azureActiveAlert = lazy(() => import("./containers/azureactivealert"));
const azurePreviousAlert = lazy(() =>
  import("./containers/azurepreviousalertrules")
);
const azureMonitorStorageAccount = lazy(() =>
  import("./containers/azuremonitorstorageaccounts")
);
const azureMonitorApplications = lazy(() =>
  import("./containers/azuremonitorapplications")
);
const azureCDN = lazy(() => import("./containers/azurecdn"));
const azureMetricsRequest = lazy(() =>
  import("./containers/azuremetricsrequest")
);
const azureMetricsResponse = lazy(() =>
  import("./containers/azuremetricsresponse")
);
const azureMetricsAvailability = lazy(() =>
  import("./containers/azuremetricsavailability")
);
const azureDashboardDetails = lazy(() =>
  import("./containers/azuredashboarddetails")
);
const azureDatabasePerformanceInsight = lazy(() =>
  import("./containers/azuredatabaseperformanceinsight")
);
const azureMetricsLogs = lazy(() => import("./containers/azuremetricslogs"));
const azureConsoleLogs = lazy(() => import("./containers/azureconsolelogs"));
const azureMetricsFailed = lazy(() =>
  import("./containers/azuremetricsfailed")
);
const azureLiveMetrics = lazy(() => import("./containers/monitoringdashboard"));
const gcpComputeInstances = lazy(() => import("./containers/gcpComputeInstances"));
const gcpCloudRun = lazy(() => import("./containers/gcpCloudRun"));
const gcpSecretManager = lazy(() => import("./containers/gcpSecretManager"));

const Routes = ({ user }) => (
  <Router basename={"/"}>
    <div className="wrapper">
      <div className="main-content">
        {user && user.api_token !== undefined && (
          <>
            <SideMenu user={user} />
          </>
        )}

        <div
          className={
            user && user.api_token !== undefined
              ? "logged-in  content-section"
              : "content-section-logout"
          }
        >
          <Suspense fallback={<div>Loading...</div>}>
            {user && user.api_token !== undefined && <Heading />}
            <Route exact path="/" component={Login} />
            <Route exact path="/register" component={Register} />
            <Route exact path="/forgot-pwd" component={forgotPwd} />
            <Route exact path="/reset-pwd/email/:token" component={resetPwd} />

            <Route
              exact
              path="/add-azure-account"
              component={RequireAuth(AddAzureAccount)}
            />
            <Route
              exact
              path="/add-gcp-account"
              component={RequireAuth(AddGCPAccount)}
            />
            <Route
              exact
              path="/user-settings"
              component={RequireAuth(UsersSettings)}
            />
            <Route exact path="/users" component={RequireAuth(users)} />
            {/* <Route
              exact
              path="/azure-accounts"
              component={RequireAuth(azure)}
            /> */}
            <Route
              exact
              path="/azure-billing"
              component={RequireAuth(azurebilling)}
            />
            <Route
              exact
              path="/azure-forecast-billing"
              component={RequireAuth(azureForecastbilling)}
            />
            <Route
              exact
              path="/azure-subcription"
              component={RequireAuth(azuresubcription)}
            />
            <Route exact path="/azure-vms" component={RequireAuth(azurevms)} />
            <Route
              exact
              path="/vms-images"
              component={RequireAuth(azurevmsimages)}
            />
            <Route
              exact
              path="/azure-databases"
              component={RequireAuth(azuredatabases)}
            />
            <Route
              exact
              path="/azure-storage-accounts"
              component={RequireAuth(azurestorageaccounts)}
            />
            <Route
              exact
              path="/az-str-container"
              component={RequireAuth(AzureStorageaccountsContainer)}
            />

            <Route exact path="/az-sites" component={RequireAuth(azureSites)} />
            <Route
              exact
              path="/az-function-app"
              component={RequireAuth(azureFunctionalApp)}
            />
            {/* <Route
              exact
              path="/az-load-balancer"
              component={RequireAuth(azureLoadBalancer)}
            /> */}
            <Route exact path="/az-cdn" component={RequireAuth(azureCDN)} />
            <Route
              exact
              path="/az-monitor-storage-account"
              component={RequireAuth(azureMonitorStorageAccount)}
            />
            <Route
              exact
              path="/az-monitor-applications"
              component={RequireAuth(azureMonitorApplications)}
            />
            <Route
              exact
              path="/az-alert-rules"
              component={RequireAuth(azureAlertRules)}
            />
            <Route
              exact
              path="/az-active-alert"
              component={RequireAuth(azureActiveAlert)}
            />
            <Route
              exact
              path="/az-previous-alert-rules"
              component={RequireAuth(azurePreviousAlert)}
            />

            <Route
              exact
              path="/azure-metrics-response"
              component={RequireAuth(azureMetricsResponse)}
            />
            <Route
              exact
              path="/azure-metrics-availability"
              component={RequireAuth(azureMetricsAvailability)}
            />
            <Route
              exact
              path="/azure-metrics-logs"
              component={RequireAuth(azureMetricsLogs)}
            />
            <Route
              exact
              path="/azure-console-logs"
              component={RequireAuth(azureConsoleLogs)}
            />
            <Route
              exact
              path="/azure-dashboard"
              component={RequireAuth(azureDashboardDetails)}
            />

            <Route
              exact
              path="/azure-activity-logs"
              component={RequireAuth(azureactivitylogs)}
            />

            <Route
              exact
              path="/azure-performance-insight"
              component={RequireAuth(azureDatabasePerformanceInsight)}
            />
            <Route
              exact
              path="/azure-metrics-request"
              component={RequireAuth(azureMetricsRequest)}
            />
            <Route
              exact
              path="/azure-metrics-failed"
              component={RequireAuth(azureMetricsFailed)}
            />
            <Route
              exact
              path="/azure-live-metrics"
              component={RequireAuth(azureLiveMetrics)}
            />
            <Route
              exact
              path="/compute-instances"
              component={RequireAuth(gcpComputeInstances)}
            />
            <Route
              exact
              path="/cloud-run"
              component={RequireAuth(gcpCloudRun)}
            />
            <Route
              exact
              path="/secret-manager"
              component={RequireAuth(gcpSecretManager)}
            />
          </Suspense>
        </div>
      </div>
      <Footer />
    </div>
  </Router>
);

const mapStateToProps = ({ LoginStore }) => LoginStore;
export default connect(mapStateToProps)(Routes);


